import React from 'react';
import { Button } from './ui/button';
import { Play, Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
import { footerLinks } from '../mock';

const iconMap = {
  Facebook: Facebook,
  Instagram: Instagram,
  Twitter: Twitter,
  Youtube: Youtube
};

const Footer = () => {
  return (
    <footer className="bg-black border-t border-zinc-900">
      {/* CTA Section */}
      <div className="bg-gradient-to-r from-red-900/20 via-red-600/20 to-red-900/20 border-b border-red-900/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4">
            Pronto Para Começar?
          </h2>
          <p className="text-gray-300 text-lg md:text-xl mb-8 max-w-2xl mx-auto">
            Junte-se a milhares de pessoas que já estão aproveitando o melhor do entretenimento
          </p>
          <a
            href="https://linkly.link/2WYOm"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-red-600 hover:bg-red-700 text-white font-bold text-lg px-10 py-6 rounded-lg shadow-2xl hover:shadow-red-600/50 transition-all hover:scale-105 flex items-center gap-2 mx-auto w-fit"
          >
            <Play className="w-6 h-6 fill-white" />
            Assista Agora!
          </a>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-red-600 p-2 rounded-lg">
                <Play className="w-6 h-6 text-white fill-white" />
              </div>
              <span className="text-2xl font-bold text-white">
                Apex <span className="text-red-600">Stream</span>
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md leading-relaxed">
              A plataforma completa de streaming para você assistir esportes, filmes e séries em qualquer lugar.
            </p>
            {/* Social Media */}
            <div className="flex gap-3">
              {footerLinks.social.map((social) => {
                const IconComponent = iconMap[social.icon];
                return (
                  <a
                    key={social.name}
                    href={social.href}
                    className="bg-zinc-900 hover:bg-red-600 p-3 rounded-lg transition-colors group"
                    aria-label={social.name}
                  >
                    <IconComponent className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Empresa</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-red-500 transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Suporte</h3>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-red-500 transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-red-500 transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © 2024 Apex Stream. Todos os direitos reservados.
            </p>
            <p className="text-gray-500 text-sm text-center md:text-right">
              Streaming legal de conteúdo licenciado
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
